<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            :loading-text="tableLoadingText"
            ajax-path="pbxware/cdrs"
            :ajax-params="{tenant_id: $route.meta.serverId}"
            date-filterable
            date-filter-value-type="YYYY-MM-DD"
            pdf
        />
    </div>
</template>

<script>
    import {secondsToHours} from '@/helpers/Formatter';

    export default {
        data() {
            return {
                refreshTable: false,
                tableIsLoading: false,
                tableLoadingText: null,
                columns: [
                    {
                        title: 'From',
                        field: 'from',
                        sorter: 'string',
                        minWidth: 180,
                    },
                    {
                        title: 'To',
                        field: 'to',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Duration',
                        field: 'duration_for_human',
                        sorter: 'string',
                        minWidth: 150,
                        bottomCalc(values, data, calcParam) {
                            let total = 0;
                            data.forEach(value => {
                                total += value.duration;
                            });

                            return secondsToHours(total);
                        }
                    },
                    {
                        title: 'Billing Duration',
                        field: 'billing_duration_for_human',
                        sorter: 'string',
                        minWidth: 200,
                        bottomCalc(values, data, calcParam) {
                            let total = 0;
                            data.forEach(value => {
                                total += value.billing_duration;
                            });

                            return secondsToHours(total);
                        }
                    },
                    {
                        title: 'Cost',
                        field: 'call_cost_for_human',
                        sorter: 'string',
                        minWidth: 150,
                        bottomCalc(values, data, calcParam) {
                            let total = 0;
                            data.forEach(value => {
                                total += value.call_cost;
                            });

                            return total.toFixed(2);
                        }
                    },
                    {
                        title: 'Start Date',
                        field: 'start_date_for_human',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Status',
                        field: 'status',
                        sorter: 'string',
                        minWidth: 150,
                        formatter({_cell}) {
                            if (_cell.value === 'Not Answered') {
                                return `<span class='badge badge-red'>${_cell.value}</span>`;
                            }

                            if (_cell.value === 'Busy') {
                                return `<span class='badge bg-orange-200 text-orange-600'>${_cell.value}</span>`;
                            }

                            return `<span class='badge badge-green'>${_cell.value}</span>`;
                        }
                    },
                ],
                actions: [

                ]
            }
        },
    }
</script>